export const apiEndpoints = {
  health: "/health",
  accountsChart: "/accounts/chart",
  me: "/me",
  meTenants: "/me/tenants",
  tenants: "/tenants",
  bankConnections: (tenantId: string) => `/tenants/${tenantId}/bank-connections`,
  bankAccounts: (tenantId: string) => `/tenants/${tenantId}/bank-accounts`,
  journalEntries: (tenantId: string) => `/tenants/${tenantId}/entries`,
  journalClassify: (tenantId: string) => `/tenants/${tenantId}/journal/classify`,
  journalEntryCreate: (tenantId: string) => `/tenants/${tenantId}/journal/entries`,
  journalEntry: (tenantId: string, entryId: string) => `/tenants/${tenantId}/entries/${entryId}`,
  journalEntryConfirm: (tenantId: string, entryId: string) => `/tenants/${tenantId}/entries/${entryId}/confirm`,
  journalEntryDiscard: (tenantId: string, entryId: string) => `/tenants/${tenantId}/entries/${entryId}/discard`,
  sync: (tenantId: string) => `/tenants/${tenantId}/fs/sync`,
  monthlySummary: (tenantId: string) => `/tenants/${tenantId}/summary/monthly`,
  receivables: (tenantId: string) => `/tenants/${tenantId}/receivables`,
  receivable: (tenantId: string, entryId: string) => `/tenants/${tenantId}/receivables/${entryId}`,
  accountBalances: (tenantId: string) => `/tenants/${tenantId}/accounts/balances`,
  reportPnl: (tenantId: string) => `/tenants/${tenantId}/reports/pnl`,
  reportBalanceSheet: (tenantId: string) => `/tenants/${tenantId}/reports/balance-sheet`,
  reportCashFlow: (tenantId: string) => `/tenants/${tenantId}/reports/cash-flow`,
  reportTrialBalance: (tenantId: string) => `/tenants/${tenantId}/reports/trial-balance`,
  fxUsdKrw: "/fx/rates/usd-krw",
  fxRevalue: (tenantId: string) => `/tenants/${tenantId}/fx/revalue`,
  fxAccounts: (tenantId: string) => `/tenants/${tenantId}/fx/accounts`,
  fxAccount: (tenantId: string, accountId: string) =>
    `/tenants/${tenantId}/fx/accounts/${accountId}`,
  fxAccountBalance: (tenantId: string, accountId: string) =>
    `/tenants/${tenantId}/fx/accounts/${accountId}/balance`,
  fxStrategy: (tenantId: string) => `/tenants/${tenantId}/fx/strategy`,
  corporationProfile: (tenantId: string) => `/tenants/${tenantId}/corporation-profile`,
  filingsUpcoming: (tenantId: string) => `/tenants/${tenantId}/filings/upcoming`,
  filingDraft: (tenantId: string, filingId: string) => `/tenants/${tenantId}/filings/${filingId}/draft`,
  filingPenaltySimulation: (tenantId: string, filingId: string) =>
    `/tenants/${tenantId}/filings/${filingId}/penalty-simulation`,
  filingRecompute: (tenantId: string, filingId: string) => `/tenants/${tenantId}/filings/${filingId}/recompute`,
  withholdingPending: (tenantId: string) => `/tenants/${tenantId}/withholding/pending`,
  withholdingFile: (tenantId: string, withholdingId: string) => `/tenants/${tenantId}/withholding/${withholdingId}/file`,
  taxInvoices: (tenantId: string) => `/tenants/${tenantId}/tax-invoices`,
  taxStrategy: (tenantId: string) => `/tenants/${tenantId}/tax/strategy`,
  adminTaxRules: "/admin/tax-rules",
  adminTaxRuleApprove: (id: string) => `/admin/tax-rules/${id}/approve`,
  adminTaxRuleChangeLog: (id: string) => `/admin/tax-rules/${id}/change-log`,
  adminTaxLawSyncState: "/admin/tax-law-sync/state",
  adminTaxLawSyncRun: "/admin/tax-law-sync/run",
  adminTaxRuleReviews: "/admin/tax-rule-reviews",
  adminTaxRuleReviewResolve: (id: string) => `/admin/tax-rule-reviews/${id}/resolve`
} as const;
